<template>
  <div>
    <div class="con-tab-ejemplo">
      <vs-list>
        <vs-list-header></vs-list-header>
        <vs-list-item v-for="res in sendSmsHistories" :key="res.id" :title="`${convFormatSeq(res.seq)} ${convFormatDateTime(res.sendDate)}`" :subtitle="`${res.remark}`">
          <vs-button class="btn-icon" size="small" color="danger" v-show="!isHideDelSendSmsHistory(res)" @click="delSendSmsHistory(res.id)">ลบ</vs-button>
        </vs-list-item>
        <div class="mt-2">
          <vs-textarea class="w-full mt-2 mb-2" v-model="form.sendSmsHistory.remark" rows="5"/>
          <vs-button class="btn-icon" size="small" color="success" @click="addSendSmsHistory()">เพิ่มข้อมูล</vs-button>
        </div>
      </vs-list>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment';
import {createNamespacedHelpers} from 'vuex'
const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');
const { mapActions: mapNotificationActions} = createNamespacedHelpers('Notification');

export default {
  data () {
    return {
      form:{
        sendSmsHistory:{
          remark: ""
        }
      }
    }
  },
  computed:{
    ...mapAccountingState([
      'status',
      'contract',
      'sendSmsHistories',
    ]),
  },
  methods: {
    ...mapAccountingActions([
      'createSendSmsHistory',
      'deleteSendSmsHistory',
    ]),
    ...mapNotificationActions(['getNotifications']),
    // Function SendSmsHistory
    isHideDelSendSmsHistory (res){
      if( res.seq >= this.sendSmsHistories.length){
        return false
      }
      return true
    },
    async addSendSmsHistory(){
      await this.createSendSmsHistory({
        contractId: this.contract.id,
        form: {
          remark: this.form.sendSmsHistory.remark,
        },
        vm: this
      })
      this.form.sendSmsHistory.remark = ""
      this.getNotifications()
    },
    async delSendSmsHistory(id){
      const vm = this
      vm.actionID = id
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: vm.acceptDelSendSmsHistory
      })
    },
    async acceptDelSendSmsHistory () {
      await this.deleteSendSmsHistory({
        form: {
          id: this.actionID
        },
        vm: this
      })
      this.getNotifications()
    },
    convFormatSeq(val){
      return `ครั้งที่ ${val}`
    },
    convFormatDateTime(val){
      return `${moment(val).format("วันที่ DD-MM-YYYY เวลา HH.mm น.")}`
    }
  },
}
</script>

<style scoped>
  .vx-coll-fixed-hight{
    display:block;
    width:100%;
    height:400px;
    overflow: auto;
  }
</style>
